import { render } from "./IntroCard.vue?vue&type=template&id=1e8728be&scoped=true"
import script from "./IntroCard.vue?vue&type=script&lang=js"
export * from "./IntroCard.vue?vue&type=script&lang=js"

import "./IntroCard.vue?vue&type=style&index=0&id=1e8728be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8728be"]])

export default __exports__